module.exports = __webpack_public_path__ + "img/25.2b6b49cb.jpg";